﻿import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
    name: 'listfilter',
    pure: true
})
@Injectable()
export class ListFilterPipe implements PipeTransform {
    transform(items: any[], field: string, value: string): any[] {
        if (!items) return [];

        if (!value) return items;

        return items.filter(it => this.multibleFilterValues(it, field, value));
    }

    multibleFilterValues(item: any, field: string, value: string): boolean {
        var isMultible = field.toString().indexOf(",") !== -1;

        if (isMultible) {
            var split = field.toString().split(",");
            for (let val of split) {
                var parsable = this.parse(item, val, value);
                if (parsable) {
                    return true;
                }
            }

            return false;
        }

        return this.parse(item, field, value);

    }

    parse(item: any, field: string, value: string): boolean {

        if (field.indexOf(".") === -1) {
            if (typeof item[field] === "string") {
                return item[field].toString().toLowerCase().indexOf(value.toLowerCase()) !== -1;
            }
            else {
                return item[field] == value;
            }

        }
        else {
            return this.parseAdvanced(item, field, value);
        }
    }

    parseAdvanced(item: any, field: string, value: string): boolean {

        let fieldProperties: string[] = field.split(".");
        let currentScope = item;

        for (let fieldProperty of fieldProperties) {

            if (currentScope[fieldProperty]) {
                currentScope = currentScope[fieldProperty];
            }
            else {
                return false;
            }

        }

        return currentScope.toString().toLowerCase().indexOf(value.toLowerCase()) !== -1;
    }
}